export const COLUMN_CONFIG = {
  priorityColumn: 'priorityColumn',
  dateCreatedColumn: 'dateCreatedColumn',
  scheduledDateColumn: 'scheduledDateColumn',
  messageColumn: 'messageColumn',
  audienceColumn: 'audienceColumn',
  totalSentColumn: 'totalSentColumn',
  opensColumn: 'opensColumn',
  openRateColumn: 'openRateColumn',
  clicksColumn: 'clicksColumn',
}
